<div class="position-relative suggestions-panel variable-panel h-100">
  <div class="d-flex gap-1 align-items-center">
    <ng-select
      class="search-style search-variable-style flex-grow-1 text-start"
      [items]="variableOptions$ | async"
      bindLabel="label"
      [loading]="loadingVariableOptions"
      [typeahead]="variableInput$"
      placeholder="Add Variables"
      appendTo="body"
      [(ngModel)]="selectedTemplateVariable"
      (ngModelChange)="selectedTemplateVariableChange.emit($event)"
      (change)="variableChange.emit($event)"
    >
      <ng-template ng-option-tmp let-item="item">
        <span>{{ item.label }}</span>
      </ng-template>
    </ng-select>
    <button
      type="button"
      class="btn btn-primary d-flex align-items-center add-variable-btn"
      (click)="addVariableClicked.emit()"
      [disabled]="!selectedTemplateVariable"
    >
      <span class="d-flex align-items-center">Add</span>
    </button>
  </div>

  <div *ngIf="selectedVariables.length > 0" class="selected-variables mt-3">
    <div class="d-flex flex-wrap gap-2">
      <span
        *ngFor="let v of selectedVariables"
        class="badge d-flex align-items-center gap-1 font-size-12"
        [ngClass]="(usedVariableKeys && usedVariableKeys.includes(v.key)) ? 'template-used-variable' : ''"
        [ngStyle]="{ 'background': (usedVariableKeys && usedVariableKeys.includes(v.key)) ? '#513DCA' : '' , 'color': (usedVariableKeys && usedVariableKeys.includes(v.key)) ? '#FFFFFF' : '' }"
      >
        <span class="pe-1">{{ v.label }}</span>
        <span
          *ngIf="showCopyIcon"
          class="copy-variable-clipboard ps-2 pe-1"
          (click)="copyVariableToClipboard.emit(v)"
          title="Click to copy {{ v.label }}"
        >
          <img
            *ngIf="usedVariableKeys && usedVariableKeys.includes(v.key)"
            src="assets/images/custom/templates/copy_icon.svg"
            alt="copy"
            class="cursor-pointer"
            width="12"
          />
          <img
            *ngIf="!(usedVariableKeys && usedVariableKeys.includes(v.key))"
            src="assets/images/custom/templates/copy_active.svg"
            alt="copy"
            class="cursor-pointer"
            width="12"
          />
        </span>
        <i class="fa fa-times cursor-pointer font-size-13 ps-2" (click)="removeVariable.emit(v)"></i>
      </span>
    </div>
  </div>
</div>


